import { useServices, ServiceRegistry } from '../contexts/ServiceContext';

/**
 * useInjectedService Hook
 * 
 * Provides a type-safe way to retrieve platform-specific services within components or hooks.
 * This is the core of the Dependency Injection (DI) pattern for the universal architecture.
 *
 * @param serviceName The key of the service to retrieve from the registry.
 * @returns The requested service instance.
 *
 * @example
 * const storage = useInjectedService('storage');
 */
export function useInjectedService<K extends keyof ServiceRegistry>(
    serviceName: K
): ServiceRegistry[K] {
    const services = useServices();
    return services[serviceName];
}
